import { combineReducers } from 'redux';
import availability from './availability';
import storeinfo from './storeinfo';
import tracking from './tracking';
export var reducers = {
  storeSelectorAvailability: availability,
  storeSelectorStoreinfo: storeinfo,
  storeSelectorTracking: tracking
};
export default combineReducers({
  storeSelectorAvailability: availability,
  storeSelectorStoreinfo: storeinfo,
  storeSelectorTracking: tracking
});